import { Link, LinkProps } from 'react-router-dom'

// ----------------------------------------------------------------------

interface RouterLinkProps extends Omit<LinkProps, 'to'> {
  href: string
}

const RouterLink = ({
  ref,
  href,
  ...other
}: RouterLinkProps & { ref?: React.RefObject<HTMLAnchorElement | null> }) => (
  <Link ref={ref} to={href} {...other} />
)

export default RouterLink
